import { SHOW_LOADER, HIDE_LOADER } from '../actions/types'

const initialState = {
  count: 0
};

export default (state = initialState, action) => {

    const { type } = action;

    switch (type) {
        case SHOW_LOADER:
            return {
                ...state,
                count: state.count + 1
            };

        case HIDE_LOADER:
            return {
                ...state,
                count: Math.max(state.count - 1, 0)
            };

        default:
            return state;
    }
}